import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FeaturesService } from '../../common/services/features.service';
import { HOME_SECTIONS, HomeCard, HomeCardLink } from './home-page.data';
import { WHATS_NEW_ENTRIES } from '../whats-new/whats-new.data';

@Component({
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent {
  readonly features = inject(FeaturesService);
  readonly sections = HOME_SECTIONS;

  /** Most recent What's New entry — shown as a small teaser block on the landing page. */
  readonly latestNews = WHATS_NEW_ENTRIES[0];

  isCardVisible(card: HomeCard): boolean {
    return !card.labsOnly || this.features.labsMode();
  }

  isLinkVisible(link: HomeCardLink): boolean {
    return !link.labsOnly || this.features.labsMode();
  }

  /** Hide a section entirely if every card it contains is labs-gated and labs is off. */
  isSectionVisible(cards: HomeCard[]): boolean {
    return cards.some(c => this.isCardVisible(c));
  }
}
